<template>
  <div>
    <carrier-reason
      ref="carrierContainer"
      :auto="car"
      @set="setReasonCarrier"
      @changed="changeOwner"
    />
    <template v-if="reasonCarrier > 0">
      <file-sts ref="trucksFiles" :auto="car" />
      <sts-truck :auto="car" @changed="changedElement" />
      <add-trailer
        ref="addTrailer"
        :car="car"
        @saved="saveAuto"
        @changed="updateAuto"
      />
    </template>
  </div>
</template>

<script>
import { filesValidateMixinParentActions } from '@/mixins/filesValidateMixin'
import AddTrailer from '@/views/Autopark/AddForms/AddTrailer'
import CarrierReason from '../Forms/CarrierReason'
import FileSts from '../Forms/FileSts'
import StsTruck from '../Forms/StsTruck'
import mixinForms from '../Mixins/forms'

export default {
  name: 'FormReasonOne',
  components: { CarrierReason, StsTruck, FileSts, AddTrailer },
  mixins: [mixinForms, filesValidateMixinParentActions],
  data() {
    return {
      returnData: {
        sts: '',
        mark: '',
        sts_date: '',
        vin: '',
        isOwner: 0,
        innOwner: '',
        nameOwner: '',
        innCarrier: '',
        nameCarrier: '',
      },
      reasonCarrier: 0,
      source_id: this.car.id,
      source_model_id: 1,
    }
  },
  methods: {
    filesIsValid() {
      const { carrierContainer: ref, addTrailer } = this.$refs || {}

      return (
        !ref ||
        (ref.checkCountFilesBeforeSave(ref.fileRefsList) &&
          this.checkCountFilesBeforeSave(['trucksFiles']) &&
          addTrailer.checkCountFilesBeforeSave(['trailerFiles']))
      )
    },
    setOwner() {
      let { inn, short_name } = this.userInfo.current.organization

      this.returnData.innCarrier = inn
      this.returnData.nameCarrier = short_name
      this.returnData.innOwner = this.reasonCarrier === 4 ? '' : inn
      this.returnData.nameOwner = this.reasonCarrier === 4 ? '' : short_name

      this.changed()
    },
    saveAuto(auto) {
      this.$emit('saved', auto)
    },
    updateAuto(auto) {
      this.$emit('changed', auto)
    },
  },
}
</script>
